import React from 'react'
import { Flex, WhiteSpace } from 'antd-mobile'
import { Checkbox } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'

import styles from './Renew.module.css'

const getTotal = (selectedEfr, memberRenewList) => {
  let total
  if (selectedEfr && JSON.stringify(selectedEfr) !== '{}') {
    total = selectedEfr.price
  } else if (excludeEfrPrice(memberRenewList)) {
    total = excludeEfrPrice(memberRenewList)
  }
  return total
}

const excludeEfrPrice = (memberRenewList) => {
  const { renewalMemberDTOS } = memberRenewList
  const freediver = renewalMemberDTOS.find((item) => !item.isEfr)
  return freediver.price
}

const getEfrPrice = (selectedEfr, memberRenewList) => {
  if (selectedEfr.isEfr && !selectedEfr.isFreediver && !selectedEfr.isScubadiver) {
    return selectedEfr.price
  } else if (JSON.stringify(selectedEfr) !== '{}' && excludeEfrPrice(memberRenewList)) {
    return selectedEfr.price - excludeEfrPrice(memberRenewList)
  } else {
    return 0
  }
}

const getDiscountPrice = (memberRenewList) => {
  const { renewalMemberDTOS } = memberRenewList
  const discount = renewalMemberDTOS.find((item) => item.discountPrice != null && !item.isEfr)
  return discount ? discount.discountPrice : 0
}

const getEfrDiscountPrice = (selectedEfr, memberRenewList) => {
  if (selectedEfr.isEfr && !selectedEfr.isFreediver && !selectedEfr.isScubadiver) {
    return selectedEfr.discountPrice
  } else if (JSON.stringify(selectedEfr) !== '{}' && excludeEfrPrice(memberRenewList)) {
    return selectedEfr.discountPrice - getDiscountPrice(memberRenewList)
  }
}

const getDiscountTotal = (selectedEfr, memberRenewList) => {
  let total
  if (selectedEfr && JSON.stringify(selectedEfr) !== '{}') {
    total = selectedEfr.discountPrice
  } else if (excludeEfrPrice(memberRenewList)) {
    total = getDiscountPrice(memberRenewList)
  }
  return total
}

const RenewStatements = ({
  memberRenewList,
  memberRenewList: { isScubadiver, isFreediver, isEfr },
  selectedEfr,
  setAgreement,
  agreement,
}) => {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.statement}>
      <div className={styles.title}>{formatMessage({ id: 'renew-statement' })}</div>
      <div className={styles['price-detail']}>
        <div className={styles['renew-price']}>
          {isScubadiver && (
            <Flex justify="center">
              <Flex.Item className="renew-price-title">Instructor</Flex.Item>
              <Flex.Item>
                <span className={getDiscountPrice(memberRenewList) ? styles.crossPrice : 'price'}>
                  ¥ {excludeEfrPrice(memberRenewList) / 100}
                </span>
                {!!getDiscountPrice(memberRenewList) && (
                  <span className={styles.price}>¥ {getDiscountPrice(memberRenewList) / 100}</span>
                )}
              </Flex.Item>
            </Flex>
          )}
          {isFreediver && (
            <div>
              <WhiteSpace />
              <Flex>
                <Flex.Item className="renew-price-title">Freediver</Flex.Item>
                <Flex.Item>
                  <span
                    className={
                      !(isScubadiver && isFreediver) && getDiscountPrice(memberRenewList) ? styles.crossPrice : 'price'
                    }
                  >
                    ¥ {isScubadiver && isFreediver ? 0 : excludeEfrPrice(memberRenewList) / 100}
                  </span>
                  {!(isScubadiver && isFreediver) && !!getDiscountPrice(memberRenewList) && (
                    <span className={styles.price}>¥ {getDiscountPrice(memberRenewList) / 100}</span>
                  )}
                </Flex.Item>
              </Flex>
            </div>
          )}
          {isEfr && (
            <div>
              <WhiteSpace />
              <Flex>
                <Flex.Item className="renew-price-title">EFRI</Flex.Item>
                <Flex.Item>
                  <span className={getEfrDiscountPrice(selectedEfr, memberRenewList) ? styles.crossPrice : 'price'}>
                    ¥ {getEfrPrice(selectedEfr, memberRenewList) / 100}
                  </span>
                  {!!getEfrDiscountPrice(selectedEfr, memberRenewList) && (
                    <span className={styles.price}>¥ {getEfrDiscountPrice(selectedEfr, memberRenewList) / 100}</span>
                  )}
                </Flex.Item>
              </Flex>
            </div>
          )}
          <Flex className="renew-total">
            <Flex.Item className="renew-price-title renew-total-title">Total</Flex.Item>
            <Flex.Item>
              <span className={getDiscountTotal(selectedEfr, memberRenewList) ? styles.crossPrice : 'price'}>
                ¥ {getTotal(selectedEfr, memberRenewList) / 100}
              </span>
              {!!getDiscountTotal(selectedEfr, memberRenewList) && (
                <span className={styles.price}>¥ {getDiscountTotal(selectedEfr, memberRenewList) / 100}</span>
              )}
            </Flex.Item>
          </Flex>
        </div>
        <Checkbox
          className={styles['agreement-box']}
          checked={agreement}
          onChange={(e) => setAgreement(e.target.checked)}
        >
          <FormattedMessage
            id="member-renew-agreement"
            values={{
              agreement: (
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles['agreement-content']}
                  href={
                    'https://pro-cms.padi.com/sites/default/files/documents/training-hub/725DTSC_%E6%95%99%E7%BB%83%E4%BC%9A%E5%91%98%E8%B5%84%E6%A0%BC%E5%92%8C%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE%E4%B9%A6_%E8%A1%A8%E5%8D%95%E9%9B%86%E5%90%88_2026.pdf'
                  }
                >
                  <FormattedMessage id="member-renew-agreement-name" />
                </a>
              ),
            }}
          />
        </Checkbox>
      </div>
    </div>
  )
}

export default RenewStatements
